var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9297 46.1872L38.5622 49.8197L45.8272 42.5547",
    stroke: "#00AC4F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4854 26.6429C29.2464 26.619 28.9596 26.619 28.6968 26.6429C23.009 26.4517 18.4923 21.7916 18.4923 16.0561C18.4684 10.201 23.2241 5.44531 29.0791 5.44531C34.9341 5.44531 39.6899 10.201 39.6899 16.0561C39.6899 21.7916 35.1492 26.4517 29.4854 26.6429Z",
    stroke: "#00AC4F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0761 52.7881C24.7266 52.7881 20.4011 51.6888 17.1031 49.4902C11.3198 45.6187 11.3198 39.3096 17.1031 35.462C23.6751 31.0648 34.4531 31.0648 41.0251 35.462",
    stroke: "#00AC4F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTick);
export default __webpack_public_path__ + "static/media/profile-tick.fd3ce91724b8ecac8eae25e2e675fbb6.svg";
export { ForwardRef as ReactComponent };